import TOS from '!!raw-loader!../assets/tos-current.html'; // eslint-disable-line
import { css } from 'css-literal-loader/styled';
import React from 'react';

import PageRoot from '../components/PageRoot';
import PageSegment from '../components/PageSegment';

const styles = require('./_terms-and-conditions-styles.module.scss');

const propTypes = {};

function TermsAndConditions() {
  return (
    <PageRoot>
      <PageSegment>
        <PageSegment.Content maxWidthMd>
          <div
            className={styles.tos}
            dangerouslySetInnerHTML={{ __html: TOS }}
          />
        </PageSegment.Content>
      </PageSegment>
    </PageRoot>
  );
}

TermsAndConditions.propTypes = propTypes;

export default TermsAndConditions;
